<form #blockInputs="ngForm">
  <glxy-form-field suffixText="px">
    <glxy-label>{{ 'EMAIL_BUILDER.SPACER_BLOCK.HEIGHT' | translate }}</glxy-label>
    <input
      matInput
      type="number"
      pattern="[0-9]*"
      inputmode="numeric"
      name="Spacer Height"
      placeholder="Optional. Defaults to 32"
      [(ngModel)]="content.spacerHeight"
      emailHoldShiftToChangeNumberFieldByTen
    />
  </glxy-form-field>
</form>
